<template>
  <div>
      <!-- {{nameid}} -->
    <vue-gauge
      :refid='nameid'
      :options="{
        hasNeedle: true,
        outerNeedle: true,
        needleStartValue: 0,
        needleColor: 'red',
        arcColors: ['#66BB6A', '#E0E0E0'],
        needleValue: 10,
        arcDelimiters: [10, 36, 78],
        centralLabel: 'meterWat',
        rangeLabel: ['0', '50'],
        needleUpdateSpeed: 1,
      }"
    ></vue-gauge>
  </div>
</template>

<script>
import VueGauge from "vue-gauge";
export default { 
     props: ["nameid"],
 };
</script>

<style>
</style>